import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/date-pickers/calendar-systems/calendar-systems.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
